import React from 'react'
import * as styles from './_MobileUnsupported.scss'
import withStyles from 'isomorphic-style-loader/withStyles'

const MobileUnsupported = () => (
  <div>
    <h1 className={styles['ag-font']}>Mobile</h1>
    <p className={styles['ag-font']}>This feature is not available on mobile. Please log in on a computer to access this feature.</p>
  </div>
)

export default ((MobileUnsupported))
